import { z } from "zod";
/** Current Tax provider policy; historical ledgers retain their original models/prices. */
/** Google Search query-count reservations are not qualified by this release. */
export const ARGON_GROUNDING_COST_BOUND_AVAILABLE = false;
/** David authorized metered fiscal Google Search without a provider query ceiling.
 * This is an estimate for admission, never a guaranteed maximum bill.
 */
export const ARGON_FISCAL_GROUNDING_ENABLED = true;
export const ARGON_GROUNDING_POLICY = {
    version: "vertex-argon-metered-search-2026-10-23.v1",
    estimatedQueriesPerCall: 50,
    searchQueryUsdPer1000: "14",
};
export const TAX_AI_MODEL = "gemini-4-argon";
export const TAX_AI_QUALIFICATION_REASON = "ARGON_COST_BOUND_UNAVAILABLE";
export const TAX_PRODUCT_IMAGE_MODEL = "imagen-4.0-fast-generate-001";
export const TAX_PRODUCT_IMAGE_PRICE_REGISTRY = {
    version: "vertex-imagen-4-fast-standard-2026-10-21.v1",
    checkedAt: "2026-10-21",
    provider: "VERTEX",
    location: "us-central1",
    tier: "STANDARD",
    model: TAX_PRODUCT_IMAGE_MODEL,
    usdPerImage: "0.02",
    maxOutputImages: 1,
    pricingSource: "https://cloud.google.com/vertex-ai/generative-ai/pricing",
};
/** Base Global/Standard public list price. No promotional credits/cache discounts. */
export const ARGON_PRICE_REGISTRY = {
    version: "vertex-argon-global-standard-2026-10-20.v1",
    checkedAt: "2026-10-20",
    provider: "VERTEX",
    location: "global",
    tier: "STANDARD",
    model: TAX_AI_MODEL,
    inputTokensUsdPerMillion: "4",
    outputTokensUsdPerMillion: "20",
    thinkingIncludedInOutput: true,
    contextTokens: 1_048_576,
    maxOutputTokens: 32_768,
    pricingSource: "https://cloud.google.com/gemini-enterprise-agent-platform/generative-ai/pricing",
    modelSource: "https://ai.google.dev/gemini-api/docs/models/gemini-4-argon",
};
/** Unknown costs must never be coerced into a zero-dollar quote. */
export const aiEstimateCostFields = {
    costUsd: z
        .string()
        .regex(/^(0|[1-9]\d{0,7})(\.\d{1,6})?$/)
        .nullable(),
    costUnavailableReason: z.literal(TAX_AI_QUALIFICATION_REASON).optional(),
};
export function refineAiEstimateCost(value, ctx) {
    if ((value.costUsd === null) !== (value.costUnavailableReason !== undefined)) {
        ctx.addIssue({
            code: "custom",
            path: ["costUsd"],
            message: "Unavailable cost requires its closed reason and no monetary quote",
        });
    }
}
//# sourceMappingURL=ai-model-policy.js.map